import { render, staticRenderFns } from "./sell.vue?vue&type=template&id=63b79b3a&scoped=true&"
import script from "./sell.vue?vue&type=script&lang=js&"
export * from "./sell.vue?vue&type=script&lang=js&"
import style0 from "./sell.vue?vue&type=style&index=0&id=63b79b3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b79b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b79b3a')) {
      api.createRecord('63b79b3a', component.options)
    } else {
      api.reload('63b79b3a', component.options)
    }
    module.hot.accept("./sell.vue?vue&type=template&id=63b79b3a&scoped=true&", function () {
      api.rerender('63b79b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inOutBound/statis/sell.vue"
export default component.exports